/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { interactionChannelDtoSchema } from "./interactionChannelDtoSchema";
import { interactionDirectionSchema } from "./interactionDirectionSchema";
import { z } from "zod/v4";

export const interactionDetailResponseDtoSchema = z.object({
    "timestamp": z.iso.datetime().describe("Business time when the interaction occurred (not necessarily when the row was created)."),
get "direction"(){
                return interactionDirectionSchema.describe("Flow relative to the tenant: inbound from a contact/prospect, outbound from the team, or unknown.")
              },
get "channel"(){
                return interactionChannelDtoSchema.describe("Structured channel details: type, optional internal reference id, and optional provider-native id.")
              }
    })